var _circle, _path, _path2, _path3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayFlowAutomation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#57B757",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_102)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_102",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 18,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 8H8V26H26V8Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_102)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1_102",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 18,
    height: 18
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 8H8V26H26V8Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1_102)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1_102",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 18,
    height: 18
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26 8H8V26H26V8Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1_102)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.25 15.125C19.25 14.0895 18.2427 13.25 17 13.25C15.7573 13.25 14.75 14.0895 14.75 15.125C14.75 16.1605 15.7573 17 17 17C18.2427 17 19.25 17.8395 19.25 18.875C19.25 19.9105 18.2427 20.75 17 20.75C15.7573 20.75 14.75 19.9105 14.75 18.875",
    stroke: "#57B757",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 12.5V13.25",
    stroke: "#57B757",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 12.5V13.25",
    stroke: "#57B757",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 20.75V21.5",
    stroke: "#57B757",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4999 17.0001C24.4999 21.14 21.14 24.5001 17 24.5001C12.86 24.5001 9.49997 21.14 9.49997 17.0001C9.49997 12.8601 12.86 9.50005 17 9.50005",
    stroke: "#57B757",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 12.5001V9.50005H21.5",
    stroke: "#57B757",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7499 13.2501L24.4999 9.50005",
    stroke: "#57B757",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_102"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayFlowAutomation);
export default __webpack_public_path__ + "static/media/PayFlowAutomation.2e05e5db65d46960587bceffc3ec51c6.svg";
export { ForwardRef as ReactComponent };